import { config } from "@/config";

const {
  constants: { SAFE_AREA_HEIGHT },
} = config;

export const getSafeElementPosition = (el: HTMLElement) => {
  const { top, bottom, left, width, height } = el.getBoundingClientRect();
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const bottomSafeArea = viewportHeight - SAFE_AREA_HEIGHT;
  const bottomDifference = bottom - bottomSafeArea;
  const isAboveViewport = top < SAFE_AREA_HEIGHT;
  const isBelowViewport = bottomDifference > 0;
  const maxHeight = viewportHeight / 2;
  const isOverflowing = height >= maxHeight;

  const resultHeight = isOverflowing ? maxHeight : height;
  let resultTop: string | number = top;
  if (isAboveViewport) {
    resultTop = SAFE_AREA_HEIGHT;
  }
  if (isBelowViewport) {
    resultTop = top - bottomDifference;
  }
  if (isOverflowing) {
    resultTop = "15%";
  }

  return { top: resultTop, bottom, left, width, height: resultHeight };
};
